<template>
<!-- Footer -->
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-10 mx-auto">
          <ul class="list-inline text-center">
            <li class="list-inline-item">
              <a href="https://twitter.com/Tauitter51">
                <span class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fab fa-twitter fa-stack-1x fa-inverse"></i>
                  </span>
              </a>
            </li>
            <li class="list-inline-item">
              <a href="https://github.com/Taurin190">
                <span class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fab fa-github fa-stack-1x fa-inverse"></i>
                  </span>
              </a>
            </li>
          </ul>
          <p class="copyright text-muted">Copyright &copy; Taurin190</p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
    name: 'common-footer'
}
</script>

